
import { Options, Vue } from 'vue-class-component'
import { mapMutations, mapState } from 'vuex'
import ShareBtn from '@/components/ShareBtn.vue'
import HomeModal from '@/components/HomeModal.vue'

@Options({
    components: { ShareBtn, HomeModal },
    computed: {
        ...mapState(['userInfo', 'aid', 'examAid', 'examData', 'countInfo']),
    },
    data() {
        return {
            showModal: false,       
            modalText: '',
            btnText: '',      
        }
    },
    methods: {
        ...mapMutations([ "SET_COUNTINFO",]),
        routerLinkTo(url: string) {
            if(url === '/rank' && new Date(this.examData.serverTime).getTime() < new Date(this.examData.endTime).getTime()) {
                this.modalText = '考试结束后开启排行榜，<br />敬请期待！';
                this.btnText = '我知道了';
                this.showModal = true;
            }
            else if(url === '/myscore' && !this.countInfo.answerTime)  {
                this.modalText = '您尚未答题，暂无个人成绩';
                this.btnText = '我知道了';
                this.showModal = true;
            }
            else if(url === '/exam' && this.countInfo.count > 0) {
                this.modalText = '您已完成答题';
                this.btnText = '我知道了';
                this.showModal = true;
            }
            else if(url === '/exam') {
                this.$common.pageLoading(true);
                this.getIsWhite()
                .then(() => {
                    this.$common.pageLoaded()
                    this.$router.push(url);
                })
                .catch((err: any) => {
                    this.$common.pageLoaded()
                    if(!err) return;
                    if(err.errno === 2001 || err.errno === 2000) {
                        this.modalText = '抱歉，您尚未进入复赛！';
                        this.btnText = '我知道了';
                        this.showModal = true;
                    }
                    else this.$common.toast(err.errmsg);
                })
            }
            else this.$router.push(url);
        },
        callBackFn() {
            this.showModal = false
        },
        getCount() {
            return this.$request(
                "/answer/user/count",
                {
                    aid: this.examAid,
                    userinfo: this.userInfo
                },
                "post"
            )
        },
        getIsWhite() {
            return this.$request(
                "/answer/user/white",
                {
                    aid: this.examAid,
                    userinfo: this.userInfo
                },
                "post"
            )
        },
    },
    mounted () {
        this.$common.pageLoaded()
        this.$common.track('load', '进入答题首页')

        this.$common.pageLoading(true)
        this.getCount()
        .then((data: any) => {
            this.SET_COUNTINFO(data);
            this.$common.pageLoaded();
        })
        .catch((err: any) => {
            this.$common.pageLoaded();
            // this.$common.toast(err.errmsg || '获取失败')
        })

    }
})
export default class ExamHome extends Vue {}
